import React from "react";
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import {diferenciasResources} from "../endpoints";
import SearchIcon from "@material-ui/icons/Search";
import {withRouter} from "react-router";
import CheckIcon from '@material-ui/icons/Check';
import SnackbarAlert from "./SnackbarAlert";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import DialogExportar from "./DialogExportar";
import useToken from "../useToken";

class TablaDetalleDifJerarquia extends React.Component{
    constructor(props) {
        let datos_inv = useToken.getDatos()
        super(props);
        this.state={
            datos: [],
            selectedRow: null,
            tipo: props.tipo,
            id: props.id,
            filtro: props.filtro,
            valor: props.valor,
            openSnack: false,
            severity: '',
            message: '',
            open:false,
            reporte:null,
            params:'',
            titulo_columna : (datos_inv.app === 'sodimac'? 'costo':'importe'),
        }
    }
    refrescar =(estado,severity) =>{
        this.setState({
            open: false,
            openSnack: true,
            message: estado,
            severity: severity})
    }

    handleClose = () =>{
        this.setState({open:false})
    }

    componentDidMount() {
        this.obtenerDiferencias()
    }

    enviarDatosReportes =(nombre)=>{
        let params = ""
        this.setState({open: true, reporte: nombre, params: params,openSnack:false})
    }

    verDetalles = (rowData) =>{
        if(this.state.filtro !== 'ninguno'){
            this.props.history.push("/detalle_diferencia_producto/"+ rowData.articulo+ '/variance')
        }
        else{
            this.props.history.push("/detalle_diferencia_producto/"+ rowData.id + "/conteo_cero")
        }
    }

    obtenerDiferencias = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        if (this.state.tipo === 'jerarquia'){
            if(this.state.filtro !== 'ninguno'){
                diferenciasResources.getDifJerarquia(this.state.id, this.state.filtro, this.state.valor).then(async response => {
                    if (response) {
                        return await response.json();
                    }
                }).then(result => {
                    if(result.status_code === 200){
                        this.setState({datos:result.diferencias})
                    }
                    else if (result.status_code === 401){
                        this.setState({openSnack:true, severity:result.severity, message:result.message})
                    }
                    else{
                        throw new Error('Something went wrong ...');
                    }
                }).catch(error=> {
                    console.log(error)
                });
            }
            else{
                diferenciasResources.getDiferenciasConteoCero().then(async response => {
                    if (response) {
                        return await response.json();
                    }
                }).then(result => {
                    if(result.status_code === 200){
                        this.setState({datos:result.diferencias})
                    }
                    else if (result.status_code === 401){
                        this.setState({openSnack:true, severity:result.severity, message:result.message})
                    }
                    else{
                        throw new Error('Something went wrong ...');
                    }
                }).catch(error=> {
                    console.log(error)
                });
            }
        }
        else{
            diferenciasResources.getDifUbicacion(this.state.id, this.state.filtro, this.state.valor).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.diferencias})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }

    }

    render() {
        return(
            <div>
                <MaterialTable
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                {this.state.filtro === 'ninguno'?
                                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                    <Grid item>
                                        <Button startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("sku_sin_inventario")}>
                                            Conteo en cero</Button>
                                    </Grid>
                                </Grid>:null}
                            </div>
                        ),
                    }}
                    actions={[
                        {
                            icon:  () => <SearchIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Ver detalle',
                            hidden: this.state.tipo === 'ubicacion',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                            position:"row"
                        },
                    ]}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=" "
                    data={this.state.datos}
                    columns={[
                        { title: 'Material', field: 'articulo', hidden: this.state.filtro === 'ninguno'},
                        { title: 'Material', field: 'id', hidden: this.state.filtro !== 'ninguno'},
                        { title: 'Descripción', field: 'descripcion',
                            cellStyle: {
                                width: 400,
                                maxWidth: 400,
                            },
                            headerStyle: {
                                width: 400,
                                maxWidth: 400
                            }},
                        { title: 'Tag.Inv.', field: 'tag_inv', hidden: this.state.tipo !== 'ubicacion'},
                        { title: 'Tag.Teo.', field: 'tag_teo', hidden: this.state.tipo !== 'ubicacion'},
                        { title: 'Inv. cantidad', field: 'inv', editable:'never',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.inv)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.inv).indexOf(term) !== -1),
                        },
                        { title: 'Teo. cantidad', field: 'teo',editable:'never',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.teo)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.teo).indexOf(term) !== -1),
                        },
                        { title: 'Dif. cantidad', field: 'dif',editable:'never',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.dif)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.dif).indexOf(term) !== -1),
                        },
                        { title: 'Inv. ' +  this.state.titulo_columna, field: 'invimp', editable:'never',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.invimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.invimp).indexOf(term) !== -1),
                        },
                        { title: 'Teo. '+  this.state.titulo_columna, field: 'teoimp',editable:'never',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.teoimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.teoimp).indexOf(term) !== -1),
                        },
                        { title: 'Dif. '+  this.state.titulo_columna, field: 'difimp',editable:'never',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.difimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.difimp).indexOf(term) !== -1),
                        },
                        { title: 'Revisado', field: 'revisado',
                            render: rowData => (rowData.revisado ? <CheckIcon/> : null),
                        }
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.open? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}

            </div>
        )
    }
}
export default withRouter(TablaDetalleDifJerarquia)